import ReactDOM from 'react-dom';
import { RecoilRoot } from 'recoil';

import '_utils/dev-tool-why-did-you-render';

import PrivateApp from 'PrivateApp';
import PublicApp from 'PublicApp';

import PageAlert from 'components/common/PageAlert/PageAlert';
import StandaloneReactPages, { verifyIsStandalonePage } from 'components/standalonePages/StandaloneReactPages';

import { initPerformanceObserver, setMark } from 'common/PerformanceLogger';
import { initUnhandledRejectionObserver } from 'common/ScalyrLogger';
import SentryMonitoring from 'common/SentryMonitoring';
import { webVitalsReportHandler } from 'common/webVitalsReportHandler';

import { useAuthenticationHandler } from 'service/auth/Auth';
import { DEFAULT_THEME, setUITheme } from 'service/browser';

import reportWebVitals from './reportWebVitals';
import * as serviceWorker from './serviceWorker';

SentryMonitoring();
initUnhandledRejectionObserver();
initPerformanceObserver();
setMark('init');
setUITheme(DEFAULT_THEME); // initialize theme

function AppRoot() {
  const { isUserAuthenticated, isUserAuthenticationPending } = useAuthenticationHandler();
  const isStandalonePage = verifyIsStandalonePage(window.location);

  if (isUserAuthenticationPending) {
    // Keep blank screen till authentication is resolved
    return null;
  }

  if (isStandalonePage) {
    return <StandaloneReactPages />;
  }

  return (
    <RecoilRoot>
      <PageAlert />
      {isUserAuthenticated ? <PrivateApp /> : <PublicApp />}
    </RecoilRoot>
  );
}

ReactDOM.render(<AppRoot />, document.getElementById('root'));

/**
 * If you want your app to work offline and load faster, you can change
 * unregister() to register() below. Note this comes with some pitfalls.
 * Learn more about service workers: {@link https://bit.ly/CRA-PWA}
 */
serviceWorker.unregister();

/**
 * More info: {@link https://bit.ly/CRA-vitals}
 */
reportWebVitals(webVitalsReportHandler);
